import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetWallet, type WalletCurrency } from '@/domain'

export const ResetTransferInOnRouteEntry: React.FC = () => {
  const location = useLocation()
  const setGoalTransferIn = useSavingsStore((state) => state.setGoalTransferIn)
  const wallet = useUserStore((s) => s.wallet)
  const displayCurrency = wallet?.displayCurrency || 'USD'
  const setWallet = useUserStore((s) => s.setWallet)

  // Получаем актуальные данные кошелька из API
  const { data: walletData, refetch: refetchWallet } = useGetWallet()

  // Используем данные из API если доступны, иначе из store
  const completeCurrencies =
    walletData?.completeCurrencies || wallet?.completeCurrencies

  // Находим USDT в кошельке пользователя для получения актуального кода валюты
  const usdtWallet = completeCurrencies?.find(
    (currency: WalletCurrency) => currency.code === 'USDT',
  )

  // Обновляем store когда получаем новые данные кошелька
  useEffect(() => {
    if (walletData) {
      setWallet(walletData)
    }
  }, [walletData, setWallet])

  useEffect(() => {
    // Проверяем, что мы находимся на странице transfer-in
    if (location.pathname.includes('/savings/transfer-in')) {
      // Принудительно обновляем данные кошелька при входе на страницу
      refetchWallet()

      // Сбрасываем суммы при входе на страницу transfer-in
      setGoalTransferIn({
        cryptoAmount: {
          amount: '0',
          code: usdtWallet?.code || 'USDT',
        },
        fiatAmount: {
          amount: '0',
          code: displayCurrency,
        },
        triggerShake: false,
        isFiatMode: false, // В отличие от first-deposit, начинаем в crypto режиме (как в RN)
      })
    }
  }, [
    location.pathname,
    setGoalTransferIn,
    displayCurrency,
    usdtWallet?.code,
    refetchWallet,
  ])

  return null
}
